<template>
  <div class="card">
    <h3 class="text-lg font-heading font-semibold text-mifo-primary mb-4">Zusammenfassung</h3>
    <div class="space-y-2">
      <div class="flex justify-between" v-if="modelValue">
        <span class="text-gray-600">Preiskategorie:</span>
        <span class="font-medium">{{ modelValue === 'standard' ? 'Standard' : 'Assistenzarzt' }}</span>
      </div>
      <div v-if="selectedAddons && selectedAddons.length > 0" class="space-y-1">
        <div class="flex justify-between">
          <span class="text-gray-600">Zusatzprodukte:</span>
          <span class="font-medium">{{ formatCurrency(addonTotal) }}</span>
        </div>
        <div class="pl-4 text-sm text-gray-700 space-y-1">
          <div v-for="p in selectedAddons" :key="p.id" class="flex justify-between">
            <span>{{ p.name }} ({{ p.quantity }}x)</span>
            <span class="whitespace-nowrap">{{ formatCurrency(p.priceCents * p.quantity) }}</span>
          </div>
        </div>
      </div>
      
      <!-- Sending costs -->
      <div v-if="sendingCosts > 0" class="flex justify-between">
        <span class="text-gray-600">Versandkosten:</span>
        <span class="font-medium">{{ formatCurrency(sendingCosts) }}</span>
      </div>
      <div class="border-t pt-2 mt-4">
        <div class="flex justify-between text-lg font-semibold">
          <span>Gesamtpreis:</span>
          <span class="text-mifo-primary">{{ formatCurrency(totalPrice) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency } from 'shared/utils'

export default {
  name: 'CheckoutSummary',
  props: {
    modelValue: { type: String, required: false, default: null },
    selectedAddons: { type: Array, default: () => [] },
    addonTotal: { type: Number, default: 0 },
    sendingCosts: { type: Number, default: 0 },
    totalPrice: { type: Number, required: true }
  },
  setup() {
    return { formatCurrency }
  }
}
</script>

